export default () => { };
//# sourceMappingURL=NativeVideoModule.web.js.map